import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import NumbersEdit from './NumbersEdit'
import { updateNumber } from 'features/Numbers/Numbers.actions'

const form = 'numberEdit'

const stateToProps = ({}, { service }) => ({
  initialValues: service,
})

const dispatchToProps = {
  updateNumber,
}

const NumbersEditForm = reduxForm({
  form,
  enableReinitialize: true,
})(NumbersEdit)

export default connect(stateToProps, dispatchToProps)(NumbersEditForm)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersEdit/NumbersEdit.container.js